import { render, staticRenderFns } from "./person.vue?vue&type=template&id=79dfcb33&scoped=true"
import script from "./person.vue?vue&type=script&lang=js"
export * from "./person.vue?vue&type=script&lang=js"
import style0 from "./person.vue?vue&type=style&index=0&id=79dfcb33&prod&lang=css"
import style1 from "./person.vue?vue&type=style&index=1&id=79dfcb33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dfcb33",
  null
  
)

export default component.exports